import { detect } from 'detect-browser';

const browser = detect();

export function detectBrowser() {
    return browser;
}

export function getBrowser() {

    switch (browser.name) {
        case 'chrome':
        case 'firefox':
        case 'crios':
        case 'fxios':
            break;
        default:
            validateIsEditor();
            break;
    }
    
}

export function validateIsEditor() {
    
    window.addEventListener("DOMContentLoaded", function() {
    
        let url = window.location.href;

        if (url.includes('/editor/') || url.includes('/professionalEditor/') || url.includes('/photoManager/')) {
            redirectToError();
        } else {
            addHidden();
        }
    });

}

export function addHidden() {
    
    let apple = false;
    let os = browser.os;
    
    if (os.includes('iOS') || os.includes('Mac OS')) {
        apple = true;
    }
    
    if (window.location.href.includes('browserError') === false && document.cookie.indexOf('shallNotAppear') == -1) {
        let warning = document.querySelector('.incorrect-browser-warning');
        let safari = document.querySelector('.third-background');

        if (apple === true) {
            safari.classList.remove('safari-shall-not-pass');
        }

        if (warning.classList.contains('incorrect-browser-warning-is-hidden')) {
            warning.classList.remove('incorrect-browser-warning-is-hidden');
        } else {
            document.cookie = "shallNotAppear=true;"
            warning.classList.add('incorrect-browser-warning-is-hidden');
        }
    }     
}

export function redirectToError() {
        
    let apple = false;
    let os = browser.os;
    
    let appDevLink = (window.location.href.indexOf("dev.php") === -1) ? "/" : "/app_dev.php/";
    let route = 'https://' + document.location.host + appDevLink;
    
    if (os.includes('iOS') || os.includes('Mac OS')) {
        apple = true;
    }
    
    if (apple === true) {
        window.location.replace(route + 'browserError?apple=true');
    } else {
        window.location.replace(route + 'browserError');
    }

}

getBrowser();